<template>

         <div class="peoplemap-part">
            <div id="viewer" class="viewer" style="width: 100vw; height: 100vh;"></div>
            <div id="container"></div>
        </div>

</template>

<script>




import { Viewer } from '@photo-sphere-viewer/core';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import { VisibleRangePlugin } from '@photo-sphere-viewer/visible-range-plugin';
import * as PANOLENS from 'panolens'
import $ from 'jquery';

export default {
    name: 'App',
    data() {
        return {

    
        };
    },

    methods: {
      
     

    },
    mounted() {
   


             const viewer = new Viewer({
                container: document.querySelector('.viewer'),
                panorama: 'images/location1/1-0-1-min.jpg',
                touchmoveTwoFingers: false,
                mousewheelCtrlKey: false,
                defaultPitch: -0.2,
                defaultYaw: -0.3,
                defaultZoomLvl:50,
                navbar: [

                ],
                plugins: [
       

                    [MarkersPlugin, {
                    // list of markers
                    markers: [
                      
                        {
                            // html marker with custom style
                            id: 'inf',
                            position: {                                 
                                "yaw": -0.5,
                                "pitch": -0.2
                                },
                            html: '<div class="infbtns"><div class="btn-title">'+this.data01[0].name+'-'+this.datatext[0].inftext+'</div></div>',
                            scale: [1, 1],
                        },      
                        {
                            id: 'location0111',
                            position: {
                                "yaw": 0,
                                "pitch": -0.3
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[1].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                       {
                            id: 'location0121',
                            position: {
                                "yaw":0.05,
                                "pitch": -0.15
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[3].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },

                        {
                            id: 'location02',
                            position: {
                                "yaw": 2.35,
                                "pitch": -0.05
                            },
                            html: '<div class="upper-btn"><div class="btn-title">'+this.data02[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data02[0].mainimg)+'"><div></div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },          
                         {
                            id: 'location03',
                            position: {
                                "yaw": 2.7,
                                "pitch": 0.05
                            },
                            html: '<div class="upper-btn"><div class="btn-title">'+this.data03[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data03[0].mainimg)+'"><div></div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },  
                                                 {
                            id: 'location04',
                            position: {
                                "yaw": -0.2,
                                "pitch": 0.05
                            },
                            html: '<div class="upper-btn"><div class="btn-title">'+this.data04[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data04[0].mainimg)+'"><div></div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },  
                            {
                                id: 'location05',
                                position: {
                                    "yaw": 0.5,
                                    "pitch": 0
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data05[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data05[0].mainimg)+'"><div></div></div>',
                                scale: [1, 1],
                                hoverScale: 1.1,
                            },  
                            {
                                id: 'location07',
                                position: {
                                    "yaw":0.18,
                                    "pitch": 0
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data07[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data07[0].mainimg)+'"><div></div></div>',
                                scale: [1, 1],
                                hoverScale: 1.1,
                            },   
 
                            {
                                // html marker with custom style
                                id: 'video',
                                position: {                                 
                                    "yaw": -0.5,
                                    "pitch": 0
                                    },
                                html: '<div class="video-btn"><div class="btn-title">'+this.datatext[0].videotext+'</div></div>',
                                scale: [1, 1],
                            },                                               
                          /*
                        {
                            id: 'location0131',
                            position: {
                                "yaw": 6.152,
                                "pitch": -0.305
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[8].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                        {
                            id: 'location0141',
                            position: {
                                "yaw": 5.7,
                                "pitch": -0.355
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[10].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                        {
                            id: 'location0151',
                            position: {
                                "yaw": 0.038,
                                "pitch": -0.359
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[11].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                        {
                            id: 'location0161',
                            position: {
                                "yaw": 5.87,
                                "pitch": -0.2
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[12].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                        {
                            id: 'location0171',
                            position: {
                                "yaw": 1.188,
                                "pitch": -0.55
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[13].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                        {
                            id: 'location0181',
                            position: {
                                "yaw": 0.015,
                                "pitch": -1.034
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[14].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                


                        {
                            // html marker with custom style
                            id: 'inf',
                            position: {                                 
                                "yaw": 0,
                                "pitch": -0.2
                                },
                            html: '<div class="infbtns"><div class="btn-title">'+this.data01[0].name+'-'+this.datatext[0].inftext+'</div></div>',
                            scale: [1, 1],
                        },                           
                        {
                            // html marker with custom style
                            id: 'inf7',
                            position: {                                 
                                "yaw": 5.88,
                                "pitch": -0.48
                                },
                            html: '<div class="infbtns"><div class="btn-title">'+this.data01[15].name+'-'+this.datatext[0].inftext+'</div></div>',
                            scale: [1, 1],
                        },       
 */

                    ],
                    
                    }],
                    [VisibleRangePlugin, {
                        verticalRange: [-Math.PI / 1, Math.PI / 4],
                    }],
                ],
            });

            const self = this

            const markersPlugin = viewer.getPlugin(MarkersPlugin);
            markersPlugin.addEventListener('select-marker', ({ marker }) => {

                if (marker.id === 'inf') {
                    this.openrightmenu();      
                }
                else if (marker.id === 'photo') {
                    this.album();
                }      
                else if (marker.id === 'video') {
                    this.video();
                }else{
                    self.link(marker); 
                }     
                  
                
            });   
           
            viewer.addEventListener('ready', () => {
            viewer.rotate({

            });
            }, { once: true });



            //vr盒
            var panorama, viewer2, container;
            container = document.querySelector( '#container' );
            panorama = new PANOLENS.ImagePanorama( 'images/location1/1-0-1-min.jpg' );
            viewer2 = new PANOLENS.Viewer( {  container: container } );
            viewer2.enableEffect( PANOLENS.MODES.STEREO ); 
            viewer2.add( panorama);
          
   

    }
}
</script>


<style scoped>

</style>
